import React from "react";
import { Outlet } from "react-router-dom";

import SuperAdminDistributionPipelineHeader from "./components/SuperAdminDistributionPipelineHeader";

export default function SuperAdminDistributionPipelineView({ channel, pipeline }) {
	return (
		<>
			<SuperAdminDistributionPipelineHeader channel={channel} pipeline={pipeline} />

			<Outlet context={{ channel, pipeline }} />
		</>
	);
}
